import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { session } = useAuth();

  const { data: subscription, isSuccess } = useQuery({
    queryKey: ["subscription", session?.user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("subscriptions")
        .select("*")
        .eq("user_id", session?.user?.id)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!session?.user?.id,
  });

  useEffect(() => {
    // Only redirect when both session exists and subscription query has completed
    if (session && isSuccess) {
      console.log("Subscription tier:", subscription?.tier); // Debug log
      if (subscription?.tier === "tester_tree") {
        console.log("Redirecting to /tree"); // Debug log
        navigate("/tree", { replace: true });
      } else {
        const from = location.state?.from?.pathname || "/";
        console.log("Redirecting to:", from); // Debug log
        navigate(from, { replace: true });
      }
    }
  }, [session, subscription, isSuccess, navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
        </div>
        <Auth
          supabaseClient={supabase}
          appearance={{ 
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: 'rgb(59 130 246)',
                  brandAccent: 'rgb(29 78 216)',
                }
              }
            }
          }}
          theme="light"
          providers={[]}
        />
      </div>
    </div>
  );
};

export default Login;